module.exports = __webpack_public_path__ + "img/quert.cbaf0b93.jpg";